import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import LibraryPage from '@/pages/LibraryPage.vue'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  { path: '/', redirect: '/library' },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: { bare: true }
  },
  {
    path: '/library',
    name: 'library',
    component: LibraryPage
  },
  {
    path: '/library/:folderId',
    name: 'folder',
    component: LibraryPage
  },
  {
    path: '/library/:folderId/capture',
    name: 'capture',
    component: () => import('@/pages/CameraCapturePage.vue')
  },
  {
    path: '/library/:folderId/scans/:scanId/crop',
    name: 'crop-editor',
    component: () => import('@/pages/CropEditorPage.vue')
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('@/pages/SearchPage.vue')
  },
  // Unknown routes fall back to the library root.
  { path: '/:pathMatch(.*)*', redirect: '/library' }
]

export const router = createRouter({
  history: createWebHistory(),
  routes
})

// Auth guard: require a session for every route except the login page.
router.beforeEach(async (to) => {
  if (to.meta.bare) return true
  const auth = useAuthStore()
  if (!auth.checked) {
    await auth.fetchSession()
  }
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  return true
})
